import * as types from '../mutation-types'
import * as api from '../api'
import router from '../../router'

const state = {
  notification: [],
  notifications: [],
  notifications_received_timestamp: new Date(0)
}

const getters = {
  singleNotification: state => state.notification,
  allNotifications: state => state.notifications
}

const actions = {
  getNotifications ({ commit }) {
    const diff = Math.abs(new Date(state.notifications_received_timestamp) - new Date())
    const diffMinutes = Math.floor((diff / 1000) / 60)
    if (diffMinutes >= 1) {
      api.instance.get('notifications')
        .then(function (response) {
          const notifications = response.data.notifications
          commit(types.RECEIVE_NOTIFICATIONS, notifications)
        })
        .catch(function (error) {
          console.log(error)
        })
    }
  },
  getNotification ({ commit }, notificationId) {
    api.instance.get('notifications/' + notificationId)
      .then(function (response) {
        const notification = response.data.notification

        if (notification.sound_type_id === 1) {
          notification.sound = {
            value: notification.sound.sound_id,
            label: notification.sound.filename
          }
          notification.playlist_id = 0
          notification.playlist = ''
        } else if ([2, 3, 4].includes(notification.sound_type_id)) {
          notification.sound_id = 0
          notification.sound = ''
        }

        notification.zone = {
          value: notification.zone.zone_id,
          label: notification.zone.name
        }

        if (notification.extension === 0) {
          notification.extension = '9'
        }

        commit(types.RECEIVE_NOTIFICATION, notification)
      })
  },
  playNotification ({ commit }, notification) {
    api.instance.post('uds_message', {
      command: 'play_announcement',
      announcement_id: notification.notification_id
    }).then(function (response) {
      if (response.data.success === 'true') {
        alert('Announcement successfully started.')
      } else {
        alert(response.data.message)
      }
    }).catch(function (error) {
      console.log(error)
    })
  },
  playTextNotification ({ commit }, notification) {
    api.instance.post('uds_message', {
      command: 'execute_text_based_alert',
      display_text: notification.display_text,
      zone_id: notification.zone_id,
      flasher_type: notification.flasher_type,
      action: notification.action,
      duration: notification.duration
    }).then(function (response) {
      if (response.data.success === 'true') {
        const s = notification.action === "start" ? "started" : "stopped"
        alert('Text notification successfully ' + s + '.')
      } else {
        alert(response.data.message)
      }
    }).catch(function (error) {
      console.log(error)
    })
  },
  addEditNotification ({ commit, state, rootGetters }, notification) {
    notification.site_id = rootGetters.scopedSiteId

    if (notification.name !== '') {
      notification.zone_id = notification.zone.value
      if (notification.zone_id !== 0 && notification.zone_id !== '0') {
        if (notification.sound_type_id === 1) {
          notification.sound_id = notification.sound.value
          notification.playlist_id = 0
          if (notification.sound === '' || notification.sound_id === 0 || notification.sound_id === '0') {
            alert('Please select a sound.')
            return
          }
        } else if ([2, 3, 4].includes(notification.sound_type_id) && notification.playlist_id === 0) {
          notification.sound_id = 0
          alert('Please select a playlist.')
          return
        }

        if (notification.extension === '') {
          notification.extension = '9'
        }

        if (notification.extension === '9') {
          notification.extension = 0
        }

        if (notification.notification_id === 0) {
          api.instance.post('notifications', notification)
            .then(function (response) {
              if (response.data.success === 'true') {
                notification = response.data.notification[0]
                commit(types.ADD_NOTIFICATION, notification)

                router.push({ name: 'Notifications' })
              } else {
                alert(response.data.message)
              }
            })
            .catch(function (error) {
              console.log(error)
            })
        } else {
          api.instance.put('notifications/' + notification.notification_id, notification)
            .then(function (response) {
              if (response.data.success === 'true') {
                notification = response.data.notification[0]
                commit(types.EDIT_NOTIFICATION, notification)
                router.push({ name: 'Notifications' })
              } else {
                alert(response.data.message)
              }
            })
            .catch(function (error) {
              console.log(error)
            })
        }
      } else {
        alert('Please select a zone.')
      }
    } else {
      alert('Name is required')
    }
  },
  deleteNotification ({ commit }, notification) {
    api.instance.delete('notifications/' + notification.notification_id)
      .then(function (response) {
        commit(types.DELETE_NOTIFICATION, notification)
      })
  }
}

const mutations = {
  [types.RECEIVE_NOTIFICATIONS] (state, notifications) {
    state.notifications = notifications
    state.notifications_received_timestamp = Date.now()
  },
  [types.RECEIVE_NOTIFICATION] (state, notification) {
    state.notification = notification
  },
  [types.ADD_NOTIFICATION] (state, notification) {
    state.notifications.push(notification)
  },
  [types.EDIT_NOTIFICATION] (state, notification) {
    let notificationToEdit = state.notifications.find(
      function (ele) {
        if (ele.notification_id === notification.notification_id) {
          return true
        }
      }
    )
    let index = state.notifications.indexOf(notificationToEdit)
    state.notifications[index] = notification
  },
  [types.DELETE_NOTIFICATION] (state, notification) {
    let notificationToDelete = state.notifications.find(
      function (ele) {
        if (ele.notification_id === notification.notification_id) {
          return true
        }
      }
    )
    let index = state.notifications.indexOf(notificationToDelete)
    state.notifications.splice(index, 1)
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
